import { FC } from 'react';
import { Box, Circle, Flex, SimpleGrid, Text } from '@chakra-ui/react';
import { CheckMarkThick } from '../../assets';

export interface AchievementStatisticsProps {
  unlockedCount: number;
  totalAchievements: number;
}

export const AchievementStatistics: FC<AchievementStatisticsProps> = (
  props: AchievementStatisticsProps
) => {
  const { unlockedCount, totalAchievements } = props;
  const unlocked = Array(unlockedCount).fill(true);
  const locked = Array(totalAchievements - unlockedCount).fill(true);

  return (
    <Flex w="full" alignItems="center" justifyContent="space-between">
      <Box flex="1" flexDirection="row">
        <Text fontSize="1.65rem">
          {unlockedCount}/{totalAchievements}
        </Text>
        <Text fontSize="xs">Achievements unlocked</Text>
      </Box>

      <Box>
        <SimpleGrid
          columns={Math.round(totalAchievements / 2)}
          spacing={1}
          color="brand.additional.white"
        >
          {unlocked.map((u, index) => (
            <Circle key={index} size={4} bg="brand.additional.success">
              <CheckMarkThick boxSize={3} />
            </Circle>
          ))}
          {locked.map((u, index) => (
            <Circle key={index + 100} size={4} bg="brand.primary.lightGrey" />
          ))}
        </SimpleGrid>
      </Box>
    </Flex>
  );
};
